import {
    Component,
    OnInit,
    Input,
    EventEmitter,
    Output,
    ChangeDetectorRef,
    ViewChild,
    OnDestroy, OnChanges, SimpleChanges, HostListener, ChangeDetectionStrategy} from '@angular/core';
import { SecurityAllocationsGridLayoutService } from './security-allocations.grid-layout.service';
import { AppService } from '@irb/app.service';
import { IrbSettingsService } from '@irb/irb-settings/irb-settings.service';
import { CalltoactionService } from '@irb/irb-common/components/calltoaction/calltoaction.service';
import { UtilityService } from '@irb/irb-common/services/utility.service';
import { IrbEditorsService } from '@irb/irb-editors/irb-editors.service';
import { IDropdownItem } from '@irb-common/models/dropdown.model';
import { SelectAllGridParent } from '@irb/irb-common/components/irebal-ag-grid-ent-avatar/irb-select-all-grid-parent';
import { ISecurityModelAllocation } from '@irb/irb-editors/irb-editors.model';
import { EditorModelService } from '@irb/irb-editors/editor-model/editor-model.service';
import { Subscription } from 'rxjs';
import { IrbModelsEvents } from '@irb/irb-models/irb-models.events';
import { IrbAppEvents } from '@irb/app.events';
import { DialogComponent } from '@irb-common/components/dialog/dialog.component';
import { IEvent } from '@irb-common/events';
import { AgGridAngular } from 'ag-grid-angular';
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';

enum SecurityAllocationViewStateEnum {
    VIEW_STATE_KEY = 'SecurityAllocationViewState',
    BASIC_VIEW = 'basicView',
    TRADING_VIEW = 'tradingView'
}
@Component({ standalone: false,
  selector: 'irb-security-allocations',
  templateUrl: './security-allocations.component.html',
  styleUrls: ['./security-allocations.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class SecurityAllocationsComponent implements OnInit, SelectAllGridParent, OnDestroy, OnChanges {
    totalRecordsFromServer: number;
    isSelectedAll: boolean;
    uniqueField: string;
    deselectedFromSelectAllRecords: any[];
    headerCheckBoxState: string;
    disableActionBtn: boolean;
    finScore: string = '--';
    finscoreToolTip: string;
    private editDataChangeSubscription: Subscription;
    totalPercent: any;
    private initLoading: boolean = true;
    private eventSubscription: Subscription;
    private reloadDataAfterRefresh: Subscription;
    private globSetSub: Subscription;
    isTLHSetInGlobal: boolean = null;
    isTlhWsaEnabled: boolean = false;
    ENABLE_AS_SECTYPE: boolean = false;

    @Output() changeData = new EventEmitter<boolean>();
    @ViewChild('securitiesDropdown') securitiesDropdown: any;
    @ViewChild("dialog") dialog: DialogComponent;

    @Input() isSubscribeModel = false;
    @Input() slot: string;

    defaultExpandedPanels: Array<string> = ["SECURITYALLOCATIONS"];
    rowCount: number;
    grid: AgGridAngular;
    gridOptionsTop: any;
    _data: any;
    sideBar: any;
    defaultColDef: any;
    securitiesList: any[] = [];
    height: string = "260px";
    addNewSecurityItem: any = {
        button: 'Add new security',
        type: 'security',
        fromComp: 'SecurityAllocationsComponent'
    };
    frameworkComponents: any;
    defaultView = localStorage.getItem(SecurityAllocationViewStateEnum.VIEW_STATE_KEY) || SecurityAllocationViewStateEnum.BASIC_VIEW ;
    SecurityAllocationViewStateEnum = SecurityAllocationViewStateEnum;
    isUiTest = false;
    componentName: string;

    constructor(
        private sagls: SecurityAllocationsGridLayoutService,
        private as: AppService,
        public iss: IrbSettingsService,
        private ctas: CalltoactionService,
        private cdr: ChangeDetectorRef,
        private util: UtilityService,
        private ies: IrbEditorsService,
        private editorModelService: EditorModelService,
        private ats: AnalyticsService
    ) {
        this.ENABLE_AS_SECTYPE = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_AS_SECTYPE;
        this.isTlhWsaEnabled = this.as.getItem('IRB_APP_CONFIG')?.isTlhWsaEnabled;
        this.editorModelService.targetMinMaxChanged = false;
        this.finscoreToolTip = this.ies.finMansonTooltip();
    }

    enableDisableBtns(): void {
    }

    clearAllFilters(): void {
    }


    isExternalFilterPresent() {
        return true;
    }

    doesExternalFilterPass(node: any) {
        return !node.data.isUIdeleted;
    }

    disableDelete(params: any) {
        if (this.isSubscribeModel) {
            return !params.data.targetPercentage;
        }
        return true;
    }

    ngOnInit(): void {
        this.updateComponentName();
        this.gridOptionsTop = {
            columnDefs: this.defaultView  === SecurityAllocationViewStateEnum.BASIC_VIEW ? this.sagls.getColumnDefs(this): this.sagls.getTradingRulesColumnDefs(this),            
            context: {componentParent: this, parentId: 'edit-model-security-allocations-component'},
            doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
            isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
            floatingFilter: false,
            rowSelection: 'multiple',
            onDisplayedColumnsChanged: () => {
                if (!this.initLoading) {
                    this.updateTargetPercentTotal();
                }
            },
            onToolPanelVisibleChanged: () => {
                this.updateTargetPercentTotal();
            },
            onDragStopped: () => {
                this.updateTargetPercentTotal();
            }
        };
        
        this.frameworkComponents = this.sagls.getFrameworkComponents();

        this.eventSubscription = this.as.getEvents().subscribe((s) => {
            this.processEvent(s);
        });
        this.editDataChangeSubscription = this.editorModelService.parametersChanged.subscribe(()=> {
            this.updateTargetPercentTotal();
        });
        setTimeout(() => {
            this.initLoading = false;
            if (this.totalPercent) {
                this.updateTargetPercentTotal();
            }
        }, 1000);

        this.reloadDataAfterRefresh = this.editorModelService.refreshData.subscribe( () => {
            this.load();
        })
    }
    @HostListener("window:resize")
    onResize() {

        setTimeout(() => {
            this.setTotalPercent(this.totalPercent);
        }, 200);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.data && this.grid) {
            this.load();
            this.finScore = this.data.finscore ? this.data.finscore : '--';
            setTimeout(() => {
                this.setTotalPercent(this.totalPercent);
            }, 200);
        }
    }

    load() {
        if (this.data) {
            if (this.grid && this.grid.api) {
                this.mapFields();
                this.grid.api.setGridOption('rowData', this.data.securityModelAllocationList);
                if (this.data.securityModelAllocationList && this.data.securityModelAllocationList.length > 5) {
                    this.height = "400px";
                }
                this.finScore = this.data.finscore ? this.data.finscore : '--';
                this.data.noOfSecurities = this.data.securityModelAllocationList.length;
            }
        }

        this.rowCount = this.getRowCount();
        this.onCellValueChanged();
    }

    onGridReady(params: any) {
        this.grid = params;
        this.getAndUpdateCategoryLabel();
        this.load();
        // this.grid.api.sizeColumnsToFit();

        if (this.data && this.data.securityModelAllocationList && this.data.securityModelAllocationList.length === 0) {
            if (this.grid && this.grid.api) {
                this.grid.api.showNoRowsOverlay();
            }
        }
    }

    enableBasicView() {
        this.gridOptionsTop.floatingFilter = false;
        this.gridOptionsTop.columnDefs = this.sagls.getColumnDefs(this);
        this.defaultView = SecurityAllocationViewStateEnum.BASIC_VIEW;
        this.updateComponentName();
        localStorage.setItem(SecurityAllocationViewStateEnum.VIEW_STATE_KEY, SecurityAllocationViewStateEnum.BASIC_VIEW);
    }

    enableTradingView() {
        this.gridOptionsTop.floatingFilter = false;
        this.gridOptionsTop.columnDefs = this.sagls.getTradingRulesColumnDefs(this);
        this.defaultView = SecurityAllocationViewStateEnum.TRADING_VIEW;
        this.updateComponentName();
        localStorage.setItem(SecurityAllocationViewStateEnum.VIEW_STATE_KEY, SecurityAllocationViewStateEnum.TRADING_VIEW);
    }

    private getAndUpdateCategoryLabel() {
        let globSet = this.editorModelService.getGlobalSettings();
        if (globSet) {
            this.updateCategoryLabel(globSet);
        } else {
            this.globSetSub = this.iss.getGlobalSettings().subscribe((globSet: any) => {
                this.editorModelService.setGlobalSettings(globSet);
                this.updateCategoryLabel(this.editorModelService.getGlobalSettings());
                this.editorModelService.changedData();
            });
        }
    }
    private updateCategoryLabel(globalSettings: any) {
        if (globalSettings && globalSettings.securityCustAttrAbbr && this.grid && this.grid.api) {
            this.grid.api.getColumnDef("customCategoryName").headerName = globalSettings.securityCustAttrAbbr;
            this.grid.api.refreshHeader();
        }
    }

    private mapFields() {
        let globalSettings = this.editorModelService.getGlobalSettings() || {};
        this.isTLHSetInGlobal = globalSettings.isTlhLotLevel || globalSettings.isTlhPositionLevel;
        if (this.data && this.data.securityModelAllocationList) {
            this.data.securityModelAllocationList.forEach((rec: any) => {
                if (rec.equivalenceQty && rec.equivalenceQty !== 0) {
                    let eqsymbol: string = 'none';
                    if (rec.secEquivalentsDtoSet && rec.secEquivalentsDtoSet.length !== 0) {
                        //rec.altIfHeldSymbol = rec.secEquivalentsDtoSet.eqSecuritySymbol;
                        rec.secEquivalentsDtoSet.forEach((secEq: any) => {
                            if (secEq.altIfHeldFlag) {
                                if (eqsymbol === 'none') {
                                    eqsymbol = secEq.eqSecuritySymbol;
                                } else {
                                    eqsymbol = 'MULTIPLE';
                                }
                            }
                        });
                    }
                    rec.altIfHeldSymbol = eqsymbol;
                }
            });
        }
    }

    private updateTargetPercentTotal() {
        this.totalPercent = this.data && this.data.securityModelAllocationList && this.data.securityModelAllocationList.length === 0 ? '' : this.editorModelService.getTotalTargetPercent();

        setTimeout(() => {
            this.setTotalPercent(this.totalPercent);
        }, 200);
    }

    cancelDelete() {
        this.ctas.remove();
    }

    updateRow(params: any, isChanged: boolean) {
        let goUpdate: boolean = true;
        const field = params.colDef.field;
        if (field === 'targetPercentage' && isChanged) {
            goUpdate = false;
            if (!params.data.useGlobalValue) {
                goUpdate = true;
                this.editorModelService.targetMinMaxChanged = true;
            } else {
                this.updateRebalanceBandfromMaster(params.data, field)
            }
            this.finScore = '--';
        }

        if (goUpdate) {
            this.updateAndRedraw(params.data, field);
        }
    }

    private updateAndRedraw(paramsData: any, field: string) {
        const securityId = paramsData.securityId;
        this.updateValueInData(field, securityId, paramsData[field]);
        this.changeData.emit(true);
        this.cdr.detectChanges();
        window.setTimeout(()=> {
            this.onCellValueChanged();
        });
    }

    private updateValueInData(field: string, securityId: number, value: any) {
        let currentValue: any;
        if (this.data && this.data.securityModelAllocationList && this.data.securityModelAllocationList.length !== 0) {
            this.data.securityModelAllocationList.forEach((sec: any) => {
                if (sec.securityId === securityId) {
                    currentValue = sec[field];
                    if (currentValue.toString() !== value.toString()) {
                        sec[field] = value.toString();
                    }
                    this.refreshUpdated(sec);
                }
            });
        }
    }
    private refreshUpdated(security: any) {
        if (security && this.grid && this.grid.api) {
            const tran: any = {
                update: [security],
            };
            this.grid.api.applyTransaction(tran);
        }
    }

    deleteAll() {
        for (let i = 0; i < this.data.securityModelAllocationList.length; i++) {
            this.data.securityModelAllocationList[i].isUIdeleted = true;
        }

        this.load();
        this.changeData.emit(true);
    }

    delete(cc: any) {

        for (let i = 0; i < this.data.securityModelAllocationList.length; i++) {
            if (this.data.securityModelAllocationList[i].securityId === cc.securityId) {
                this.data.securityModelAllocationList[i].isUIdeleted = true;

                break;
            }
        }

        this.load();
        this.changeData.emit(true);
        this.cdr.detectChanges();
        this.checkCategoriesColors();
    }

    onCellValueChanged() {
        if (this.data && this.data.securityModelAllocationList) {
            this.editorModelService.createCustCatMap(this.data.securityModelAllocationList);
            this.editorModelService.changedData();
            this.updateTargetPercentTotal();
        }
    }

    @Input()
    get data(): any {
        return this._data;
    }

    set data(d: any) {
        this._data = d;
    }

    getRowCount() {
        return (this.data && this.data.securityModelAllocationList) ? this.data.securityModelAllocationList.filter((x: any) => x.isUIdeleted === false).length : 0;
    }

    getSecurities(searchStr: any) {
        if (!searchStr || (searchStr && searchStr.trim() === '')) {
            this.securitiesDropdown.set([]);
            return;
        }
        const sortByKey = this.util.sortByKey;
        this.ies.getSecuritiesSearchDropDown(searchStr).subscribe((data: any) => {
            sortByKey(data.items, "securitySymbol", "asc");
            this.securitiesDropdown.set(DropdownFilterComponent.getFilteredList(searchStr,data.items));
        });
    }

    onSecuritiesChange(s: Array<IDropdownItem>) {
        this.securitiesList = s;
    }

    addSecuritiesFromDropdown() {
        const sa: number[] = [];
        let showDuplicateToast: boolean = false;
        let deletedIsBack: boolean = false;

        this.securitiesList.forEach((s: IDropdownItem) => {
            let isExisting = false;

            this.data.securityModelAllocationList.forEach((security: any) => {
                if (security.securityId === s.value) {
                    if (!security.isUIdeleted) {
                        isExisting = true;
                        showDuplicateToast = true;
                    } else {
                        isExisting = true;
                        security.isUIdeleted = false;
                        deletedIsBack = true;
                    }
                }    
            });

            if(!isExisting) {
                sa.push(s.value);
            }
        });
        if (sa.length === 0 && deletedIsBack) {
            this.load();
            this.changeData.emit(true);
            this.cdr.detectChanges();
        }
        if (showDuplicateToast) {
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: "warn",
                summary: "",
                detail: "Security(ies) cannot be listed twice.",
            });
        }

        if(sa.length > 0) {
            this.ies.getSecuritieAllocations(sa).subscribe((data: ISecurityModelAllocation[]) => {
                let newSecurityItem;
                for (const item of data) {
                    newSecurityItem = this.setItemsBasedOnSymbIDToGrid(item);
                    this.data.securityModelAllocationList.push(newSecurityItem);
                }

                this.load();
                this.changeData.emit(true);
                this.cdr.detectChanges();
                this.checkCategoriesColors();
            });
        }

        this.securitiesDropdown.clear();
    }

    // onCreateNewSecurity() {
    //     const dataParam: any = {
    //         editModel: true
    //     };
    //     this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
    // }

    private setItemsBasedOnSymbIDToGrid(response: any) {
        let inverseSubSymb: string = null;
        let invrsAccountType: string = null;
        let taxAltSymbolName: string = response.taxQualAltSecSymb;
        if (response.taxableAlternativeSymbol != null) {
            inverseSubSymb = response.taxableAlternativeSymbol;
            invrsAccountType = 'TAXABLE';

        } else if (response.qualifiedAlternativeSymbol != null) {
            inverseSubSymb = response.qualifiedAlternativeSymbol;
            invrsAccountType = 'QUALIFIED';
        }
        if (!taxAltSymbolName) {
            taxAltSymbolName = inverseSubSymb;
        }

        const secEquivalentsDtoSetList = response.secEquivalentsDtoSet;
        if (secEquivalentsDtoSetList != null) {
            for (let i = 0; i < secEquivalentsDtoSetList.length; i++) {
                secEquivalentsDtoSetList[i].isNew = true;
            }

        }
        const newSecurityItem: any = {
            'securityId': response.securityId,
            'securitySymbol': response.securitySymbol,
            'securityDescription': response.securityDescription,
            'securityType': response.securityType,
            'sacSecurityType': response.sacSecurityType,
            'customCategoryName': response.customCategoryName,
            'netExpenseRatio': response.netExpenseRatio,
            'targetPercentage': null,
            'useGlobalValue': true,
            'toleranceMinPercentage': null,
            'toleranceMaxPercentage': null,
            'useSecurityValue':true,
            'buyMinimum': response.buyMinimum,
            'sellMinimum': response.sellMinimum,
            'buyMinimumPercent': response.buyMinimumPercent,
            'sellMinimumPercent': response.sellMinimumPercent,
            'taxabilityBias': response.taxabilityBias,
            'rothLevel': (response.rothLevel == null) ? 0 : response.rothLevel,
            'inverseSubSymb': inverseSubSymb,
            'taxAltSymbolName': taxAltSymbolName,
            'inverseAccType': invrsAccountType,
            'equivalenceQty': response.equivalenceQty,
            'altIfHeldSymbol': response.altIfHeldSymbol,
            'secEquivalentsDtoSet': secEquivalentsDtoSetList,
            'tradeMinimumAlternative': response.tradeMinimumAlternative,
            'sellingTreatment': response.sellingTreatment,
            'conditions': response.conditions,
            'conditionsObj': {
                'conditions': (response.conditions != null) ? response.conditions : 'n/a',
                'altSecuritySymbol': response.altSecuritySymbol
            },
            'altSecurityId': response.altSecurityId,
            'altSecuritySymbol': response.altSecuritySymbol,
            'altSecuritydesc': response.altSecuritydesc,
            'isNew': true,
            'isUIdeleted': false,
            'tradeMinAltName': response.tradeMinAltName || response.tradeMinimumAlternativeSymb,
            'categoryColor': this.editorModelService.getColorByCategory(response.customCategoryName ? response.customCategoryName : 'Uncategorized'),
            'isTlhEnabled': response.isTlhEnabled,
            'tlhWashSaleAltSecuritiesDTO': response.tlhWashSaleAltSecuritiesDTO,
            'tlhWashSaleSymbol': response.tlhWashSaleSymbol || "None",
            acLevel4: response.acLevel4,
            acLevel3: response.acLevel3,
            acLevel2: response.acLevel2,
            acLevel1: response.acLevel1,
            styleBoxLabel: response.styleBoxLabel
        };
        return newSecurityItem;
    }

    private checkCategoriesColors() {
        if (this.data && this.data.securityModelAllocationList) {
            let rowIdx: number, mapColor: string;
            if (this.grid && this.grid.api) {
                this.grid.api.forEachNode((node: any) => {
                    rowIdx = node.rowIndex;
                    mapColor = this.editorModelService.getColorByCategory(node.data.customCategoryName ? node.data.customCategoryName : 'Uncategorized');
                    if (mapColor !== node.data.categoryColor) {
                        node.data.categoryColor = mapColor;
                        this.reDrawByIndex(rowIdx);
                    }
                });
            }
        }
    }

    private getModelPositions() {
        const modelPositions: any = {
            modelId: this.data.securityModelId,
            modelName: this.data.securityModelName
        };
        const positions: any = [];
        let item: any;
        this.data.securityModelAllocationList.forEach((sec: ISecurityModelAllocation) => {
            if (!sec.isUIdeleted) {
                item = {
                    symbol: sec.securitySymbol,
                    targetPercentage: sec.targetPercentage
                };
                positions.push(item);
            }
        });
        modelPositions.positions = positions;
        return modelPositions;
    }
    getFinMasonScore() {
        this.ats.trackClickEvent("lc_finmason");

        this.ies.getModelFinscore(this.getModelPositions()).subscribe((finScore: any) => {
            if (finScore.finscore && finScore.finscore.toString() !== '0') {
                this.finScore = finScore.finscore;
            } else {
                this.finScore = '--';
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'error',
                    summary: 'FinScore Not Available',
                    detail: 'The model may be targeting an unrecognized security, e.g. custom, group, SMA, etc.'
                });
            }
        }, () => {
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'error',
                summary: 'FinScore Not Available',
                detail: 'The model may be targeting an unrecognized security, e.g. custom, group, SMA, etc.'
            });
        });
    }

    setTotalPercent(totalValue: any) {
        totalValue = totalValue ? totalValue : 0;
        let agridHeaderTargets = document.querySelectorAll('#edit-security-allocation-grid .ag-header-cell');
        let totalWidthLeft = 0;
        if(agridHeaderTargets && agridHeaderTargets.length > 0) {
            let targetElIndex: any = 4;
            agridHeaderTargets.forEach((targetEl,index)=>{
                if(targetEl.classList.contains('editHeaderModelPercent')) {
                    targetElIndex = index;
                }
            });
            for(let i =0; i< targetElIndex;i++) {
                let elPos = agridHeaderTargets[i].getBoundingClientRect();
                totalWidthLeft+= elPos.width;
            }

            const headerTarget = document.querySelector('.editHeaderModelPercent');
            if (headerTarget) {
                const pos = headerTarget.getBoundingClientRect();
                // let leftPos = pos.left + pos.width - 88;
                // leftPos = leftPos < 230 ? 230 : leftPos;
                // if (Number(totalValue) < 100) {
                //     leftPos += 5;
                // }

                const totalValEl: any = document.querySelector('#edit-secallocation-grid-totalper');
                if (totalValEl) {
                    totalValEl.style.left = totalWidthLeft + 'px';
                    totalValEl.style.width = pos.width + 'px';
                    totalValEl.innerHTML = totalValue.toFixed(1) + '%';
                }
                const finscoreEl: any = document.querySelector('#edit-secallocation-finscore-totalper');
                if (finscoreEl) {
                    finscoreEl.style.left = totalWidthLeft + 'px';
                    finscoreEl.style.width = pos.width + 'px';
                    if (totalValue !== 100) {
                        this.finScore = '--';
                    }
                }

            }
        }
    }

    showAddMultipleSecuritiesDialog() {
        let dataInputForMultipleSelection: any = [];
        if (this.grid && this.grid.api) {
            this.grid.api.forEachNode(function (node: any) {
                if (!node.data.isUIdeleted) {
                    dataInputForMultipleSelection.push(node.data);
                }
            });
        }
        const params = {
            type: 'securityModel',
            data: dataInputForMultipleSelection
        };
        this.as.fireEvent(IrbModelsEvents.SHOW_MASTER_MULTIPLE_SECURITY, params);
    }

    private processEvent(event: IEvent) {
        switch (event.type) {
            case IrbAppEvents.GRID_COLUMN_RESET:
                this.clearAllFilters();
                this.updateTargetPercentTotal();
                break;
            case IrbModelsEvents.SAVE_MASTER_MULTIPLE_SECURITY:
                if (event.data && event.data.type === 'securityModel') {
                    this.addSecuritiesFromMaster(event.data);
                }
                break;
            case IrbModelsEvents.SAVE_EDIT_SECURITY:
                if (event.data && event.data.editModel === true) {
                    this.editSecurity(event.data);
                }
                break;
            case IrbModelsEvents.SAVE_CREATE_NEW_SECURITY:
                // if (event.data && event.data.editModel === true) {
                //     this.addNewlyCreated(event.data);
                // }
                if (event.data) {
                    if (event.data.type === 'security' && event.data.fromComp === 'SecurityAllocationsComponent') {
                        this.resetSecuritySearch(event.data)
                    }
                }
                break;
        }
    }

    private addSecuritiesFromMaster(eventData: any) {
        let isDuplicate: boolean = false;
        if (eventData.selectedSecurities && eventData.selectedSecurities.length !== 0) {
            eventData.selectedSecurities.forEach((newSec: any) => {
                if (this.ifNotSecurityExists(newSec.securityId)) {
                    const existSec: Array<any> = this.data.securityModelAllocationList.filter((s: any) => s.securityId === newSec.securityId);
                    if (existSec.length === 1) {
                        existSec[0].isUIdeleted = false;
                    } else {
                        this.data.securityModelAllocationList.push(this.setItemsBasedOnSymbIDToGrid(newSec));
                    }
                } else {
                    isDuplicate = true;
                }
            });
            if (isDuplicate) {
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: "warn",
                    summary: "",
                    detail: "Security(ies) cannot be listed twice.",
                });
            }
            this.load();
            this.changeData.emit(true);
            this.cdr.detectChanges();
            this.checkCategoriesColors();
        }
    }

    private ifNotSecurityExists(securityId: any) {
       const existSec:Array<any> = this.data.securityModelAllocationList.filter((s: any) => s.securityId === securityId);
       let retValue = existSec.length === 0;
       if (existSec.length === 1) {
           if (existSec[0].isUIdeleted === true) {
               return true;
           }
       }
       return retValue;
    }

    private editSecurity(updatedSec: any) {
        let rowIdx: number;
        if (!updatedSec.security) {
            return;
        }
        const updatedSecurityId = updatedSec.security.securityId;
        const sec: any = updatedSec.security;
        if (this.grid && this.grid.api) {
            this.grid.api.forEachNode((node: any) => {
                if (node.data.securityId === updatedSecurityId) {
                    rowIdx = node.rowIndex;
                    let inverseSubSymb: string = null;
                    let invrsAccountType: string = null;
                    let taxAltSymbolName: string = sec.taxAltSymbolName;
                    if (sec.taxableAlternativeSymbol) {
                        inverseSubSymb = sec.taxableAlternativeSymbol;
                        invrsAccountType = 'TAXABLE';

                    } else if (sec.qualifiedAlternativeSymbol) {
                        inverseSubSymb = sec.qualifiedAlternativeSymbol;
                        invrsAccountType = 'QUALIFIED';
                    }
                    if (!taxAltSymbolName) {
                        taxAltSymbolName = inverseSubSymb;
                    }

                    node.data.buyMinimum = sec.buyMinimum;
                    node.data.sellMinimum = sec.sellMinimum;
                    node.data.buyMinimumPercent = sec.buyMinimumPercent;
                    node.data.sellMinimumPercent = sec.sellMinimumPercent;
                    node.data.rothLevel = sec.rothLevel === null ? 0 : sec.rothLevel;
                    node.data.taxabilityBias = sec.taxabilityBias;
                    node.data.taxableAlternativeSymbol = sec.taxableAlternativeSymbol;
                    node.data.qualifiedAlternativeSymbol = sec.qualifiedAlternativeSymbol;
                    node.data.inverseSubSymb = inverseSubSymb;
                    node.data.taxAltSymbolName = taxAltSymbolName;
                    node.data.inverseAccType = invrsAccountType;
                    node.data.equivalenceQty = sec.equivalenceQty;
                    node.data.altIfHeldSymbol = sec.altIfHeldSymbol;

                    let secEquivalentsDtoSetList: any = [], newAltIfHeldSymbol: string = '';
                    if (sec.secEquivalentsDtoSet !== null && sec.secEquivalentsDtoSet.length > 0) {
                        for (let i = 0; i < sec.secEquivalentsDtoSet.length; i++) {
                            // sec.secEquivalentsDtoSet[i].isNew = true;
                            // sec.secEquivalentsDtoSet[i]["isUIdeleted"] = false;
                            delete sec.secEquivalentsDtoSet[i].equivalentCategoryId;
                            secEquivalentsDtoSetList.push(sec.secEquivalentsDtoSet[i]);
                            if (sec.secEquivalentsDtoSet[i].altIfHeldFlag) {
                                newAltIfHeldSymbol = newAltIfHeldSymbol === '' ? sec.secEquivalentsDtoSet[i].eqSecuritySymbol : 'MULTIPLE';
                            }
                        }
                        node.data.equivalenceQty = sec.secEquivalentsDtoSet.length;
                        if (newAltIfHeldSymbol !== '') {
                            node.data.altIfHeldSymbol = newAltIfHeldSymbol;
                        }
                    } else {
                        secEquivalentsDtoSetList = null;
                    }

                    node.data.secEquivalentsDtoSet = secEquivalentsDtoSetList;
                    node.data.tradeMinimumAlternative = sec.tradeMinimumAlternative ? sec.tradeMinimumAlternative : null;
                    node.data.tradeMinAltName = sec.tradeMinAltName || sec.tradeMinimumAlternativeSymb;
                    node.data.sellingTreatment = sec.sellingTreatment;
                    node.data.conditions = sec.conditions;
                    node.data.altSecurityId = sec.altSecurityId;
                    node.data.altSecuritySymbol = sec.altSecuritySymbol;
                    node.data.altSecuritydesc = sec.altSecuritydesc;

                    node.data.isTlhEnabled = sec.isTlhEnabled;
                    node.data.tlhWashSaleAltSecuritiesDTO = sec.tlhWashSaleAltSecuritiesDTO;
                    node.data.tlhWashSaleSymbol = sec.tlhWashSaleSymbol || "None";
                }
            });
        }
        if (typeof rowIdx !== 'undefined') {
            this.reDrawByIndex(rowIdx);
        }
        this.changeData.emit(true);
        this.cdr.detectChanges();
    }

    onRowChange(rowIndex: number, rowData: any, field: string) {
        if (this.grid && this.grid.api) {
            this.grid.api.forEachNode((node: any) => {
                if (node.data.securityId === rowData.securityId) {
                    rowIndex = node.rowIndex;
                }
            });
        }

        if (field === 'useGlobalValue') {
            if (rowData['useGlobalValue'] === true)
                this.updateRebalanceBandfromMaster(rowData, null, rowIndex);
            else
                this.reDrawByIndex(rowIndex);
        }
        if (field === 'useSecurityValue') {
            if (!rowData['useSecurityValue']) {
                this.openEditSecuritySlide(rowData);
                this.reDrawByIndex(rowIndex);
            } else {
                let secArray: Array<number> = [];
                secArray.push(rowData['securityId']);
                this.ies.getSecuritieAllocations(secArray).subscribe((masterSec: any) => {
                    if (masterSec && masterSec.length !== 0) {
                        this.updateSecurityFromMaster(masterSec[0], rowIndex);
                    }
                });
            }
        }
        this.changeData.emit(true);
    }

    private reDrawByIndex(rowIndex: number) {
        if (this.grid && this.grid.api) {
            const n = this.grid.api.getDisplayedRowAtIndex(rowIndex);
            this.grid.api.redrawRows({rowNodes: [n]});
        }
    }

    private updateSecurityFromMaster(masterSec: any, rowIndex: number) {
        if (this.grid && this.grid.api) {
            this.grid.api.forEachNode((node: any) => {
                if (node.data.securityId === masterSec.securityId) {

                    let inverseSubSymb: string = null;
                    let invrsAccountType: string = null;
                    let taxAltSymbolName: string = masterSec.taxQualAltSecSymb;
                    if (masterSec.taxableAlternativeSymbol != null) {
                        inverseSubSymb = masterSec.taxableAlternativeSymbol;
                        invrsAccountType = 'TAXABLE';

                    } else if (masterSec.qualifiedAlternativeSymbol != null) {
                        inverseSubSymb = masterSec.qualifiedAlternativeSymbol;
                        invrsAccountType = 'QUALIFIED';
                    }
                    if (!taxAltSymbolName) {
                        taxAltSymbolName = inverseSubSymb;
                    }

                    node.data.buyMinimum = masterSec.buyMinimum;
                    node.data.sellMinimum = masterSec.sellMinimum;
                    node.data.buyMinimumPercent = masterSec.buyMinimumPercent;
                    node.data.sellMinimumPercent = masterSec.sellMinimumPercent;
                    node.data.rothLevel = masterSec.rothLevel === null ? 0 : masterSec.rothLevel;
                    node.data.taxabilityBias = masterSec.taxabilityBias;
                    node.data.taxableAlternativeSymbol = masterSec.taxableAlternativeSymbol;
                    node.data.qualifiedAlternativeSymbol = masterSec.qualifiedAlternativeSymbol;
                    node.data.inverseSubSymb = inverseSubSymb;
                    node.data.taxAltSymbolName = taxAltSymbolName;
                    node.data.inverseAccType = invrsAccountType;
                    node.data.equivalenceQty = masterSec.equivalenceQty;
                    node.data.altIfHeldSymbol = masterSec.altIfHeldSymbol;

                    let secEquivalentsDtoSetList: any = [];
                    if (masterSec.secEquivalentsDtoSet !== null && masterSec.secEquivalentsDtoSet.length > 0) {
                        for (let i = 0; i < masterSec.secEquivalentsDtoSet.length; i++) {
                            masterSec.secEquivalentsDtoSet[i].isNew = true;
                            masterSec.secEquivalentsDtoSet[i]["isUIdeleted"] = false;
                            // delete masterSec.secEquivalentsDtoSet[i].equivalentCategoryId;
                            secEquivalentsDtoSetList.push(masterSec.secEquivalentsDtoSet[i]);
                        }
                    } else {
                        secEquivalentsDtoSetList = null;
                    }

                    node.data.secEquivalentsDtoSet = secEquivalentsDtoSetList;
                    node.data.tradeMinimumAlternative = masterSec.tradeMinimumAlternative;
                    node.data.tradeMinAltName = masterSec.tradeMinAltName || masterSec.tradeMinimumAlternativeSymb;
                    node.data.sellingTreatment = masterSec.sellingTreatment;
                    node.data.conditions = masterSec.conditions;
                    node.data.altSecurityId = masterSec.altSecurityId;
                    node.data.altSecuritySymbol = masterSec.altSecuritySymbol;
                    node.data.altSecuritydesc = masterSec.altSecuritydesc;
                    node.data.categoryColor = this.editorModelService.getColorByCategory(masterSec.customCategoryName ? masterSec.customCategoryName : 'Uncategorized');

                    node.data.isTlhEnabled = masterSec.isTlhEnabled;
                    node.data.tlhWashSaleAltSecuritiesDTO = masterSec.tlhWashSaleAltSecuritiesDTO;
                    node.data.tlhWashSaleSymbol = masterSec.tlhWashSaleSymbol || "None";
                }
            });
        }

        this.reDrawByIndex(rowIndex);
    }

    openEditSecuritySlide(rowData: any) {
        rowData.taxQualAltSecSymb = rowData.taxAltSymbolName;
        if (rowData.inverseAccType && rowData.taxAltSymbolName && rowData.taxAltSymbolName !== 'none' && rowData.taxAltSymbolName !== 'MULTIPLE') {
            this.getSecurityBySymbol(rowData)
        } else {
            this.fireEditSecurity(rowData);
        }
    }

    private getSecurityBySymbol(rowData: any) {
        let secId: any;
        let searchStr: string = rowData.taxAltSymbolName.replace('#','');
        if (!searchStr || (searchStr && searchStr.trim() === '')) {
            this.fireEditSecurity(rowData);
            return;
        }
        this.ies.getSecuritiesSearchDropDown(searchStr).subscribe((secs: any) => {
            if (secs.items && secs.items.length !== 0) {
                for(let i = 0; i < secs.items.length; i++) {
                    if (secs.items[i].name === rowData.taxAltSymbolName) {
                        secId = secs.items[i].value;
                        break;
                    }
                }
                if (secId) {
                    if (rowData.inverseAccType.toUpperCase() === 'QUALIFIED') {
                        rowData.qualifiedAlternativeSymbol = secId;
                    }
                    if (rowData.inverseAccType.toUpperCase() === 'TAXABLE') {
                        rowData.taxableAlternativeSymbol = secId;
                    }
                   this.fireEditSecurity(rowData);
                }
            }
        });
    }

    private fireEditSecurity(rowData: any) {
        const nextSlot = this.slot === "B" ? "C" : "B";
        const dt = {
            slot: nextSlot,
            editModel: true,
            data: JSON.parse(JSON.stringify(rowData)),
            modelName: this.data.securityModelName
        };
        this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_SECURITY, dt);
    }

    private updateRebalanceBandfromMaster(rowData: any, field?: string, rowIndex?: number) {
        const secModelTarget = [{
            secId: rowData.securityId,
            targetPercentage: rowData.targetPercentage,
            modelId: this.data.securityModelId
        }];
        this.ies.getAutoToleranceValues(secModelTarget).subscribe((newMinMaxData: any) => {
            if (newMinMaxData && Array.isArray(newMinMaxData) && newMinMaxData.length !== 0) {
                rowData['toleranceMinPercentage'] = newMinMaxData[0].autoToleranceMinValue;
                rowData['toleranceMaxPercentage'] = newMinMaxData[0].autoToleranceMaxValue;
                if (field) {
                    this.updateAndRedraw(rowData, field);
                } else {
                    this.reDrawByIndex(rowIndex);
                }
            }
        });
    }


    ngOnDestroy(): void {
        if (this.editDataChangeSubscription) {
            this.editDataChangeSubscription.unsubscribe();
        }
        if (this.eventSubscription){
            this.eventSubscription.unsubscribe();
        }
        if (this.reloadDataAfterRefresh) {
            this.reloadDataAfterRefresh.unsubscribe();
        }
        if (this.globSetSub) {
            this.globSetSub.unsubscribe();
        }
    }

    openNewItemSecurityFlow(dataParam: any) {
        dataParam = Object.assign({}, this.addNewSecurityItem, dataParam);
        dataParam.editModel = true;
        this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
    }

    resetSecuritySearch(dataParam: any) {
        if (dataParam && dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
            this.securitiesDropdown.setValue(dataParam.newItemsForDD);
            this.securitiesList = dataParam.newItemsForDD;
        }
    }

    updateComponentName() {
        this.componentName = (this.defaultView  === SecurityAllocationViewStateEnum.BASIC_VIEW) ? "SecurityAllocationsComponent-basicview-v002" : "SecurityAllocationsComponent-tradingview-v002";

        if(this.ENABLE_AS_SECTYPE) {
            this.componentName = this.componentName + "-enableASSecType"
        }
    }
}

